// extracted by mini-css-extract-plugin
export default {"container":"index_container__rOnO+","mainPanel":"index_mainPanel__ZEvmM","selectedPanel":"index_selectedPanel__8Wk7X"};